import AsyncStorage from '@react-native-async-storage/async-storage'
import AsyncKeys from '../AsyncKeys'

const authenticateWithAPI = async () => {
  const jsonUser = await AsyncStorage.getItem(AsyncKeys.USER_KEY)
  return JSON.parse(jsonUser)
}

export default authenticateWithAPI
